// Module
var code = "<div class=\"depicter-loading-light depicter-dot-replacing\"> <span></span> <span></span> <span></span> </div>";
// Exports
module.exports = code;